import loopStyles from "common/styles"
import { AnimatePresence, motion } from "framer-motion"
import { useState } from "react"
import styled from "styled-components"
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useDispatch, useSelector } from "react-redux";
import { Feature } from "common/feature";
import { selectFeatureViaID } from "store/reducers/map";

type TeamSidebarGroupProps = {
    children?: any,
    header?: any,
    name: string,
    teams?: any[],
}

const TeamSidebarGroup = (props: TeamSidebarGroupProps) => {
    const dispatch = useDispatch()

    const selectedFeatureData = useSelector((state: any) => state.map.selectedFeatureData)

    const [isOpen,  setIsOpen] = useState(false)

    const toggleIsOpen = () => {
        setIsOpen(!isOpen)
    }

    const mapTeamToListItem = (feature: Feature, index: number): React.ReactElement => {
        const selected = selectedFeatureData?.featureID === feature.featureID;

        const selectFeature = () => {
            dispatch(selectFeatureViaID({ featureID: feature.featureID }))
        }

        return <ListItem key={index} color={loopStyles.colors.primary} onClick={selectFeature}>
            {/* <Bg color={loopStyles.colors.primary} /> */}
            <ListItemIconContainer
                color={loopStyles.colors.tertiary}
                onClick={selectFeature}
            >
                {selected ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}
            </ListItemIconContainer>
            <div style={{flex: 1, whiteSpace: 'normal', marginLeft: '10px', fontFamily: 'Poppins', fontSize: '14px', color: '#B5B5BE', zIndex: 999}}>{feature.Name}</div>
        </ListItem>
    }

    const { teams, name } = props;

    return <Container>
        <div onClick={toggleIsOpen}>
            <SidebarGroupHeader style={{ borderBottom: `1px solid ${isOpen ? loopStyles.colors.tertiary : 'transparent'}`}}>
                <div style={{flex: 1, textAlign: 'start', marginLeft: '0px', whiteSpace: 'nowrap', fontSize: '14px', userSelect: 'none'}}>{name}</div>
                {isOpen ? <ExpandMore /> : <ExpandLess />}
            </SidebarGroupHeader>
        </div>
        <AnimatePresence>
            {isOpen && <ExpandableChildren 
                initial={{ height: 0, opacity: 0 }}
                exit={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                transition={{ duration: 0.2, type: "tween" }}
            >
                <div style={{padding: '20px 0 10px'}}>
                    <AnimatePresence exitBeforeEnter>
                        <motion.div 
                            key='true'
                            initial={{opacity: 0,}}
                            exit={{opacity: 0,}}
                            animate={{opacity: 1,}}
                            transition={{duration: 0.2}}
                        >
                            {teams?.length ? teams.map(mapTeamToListItem) : <EmptyMessage>{`There are no teams to display.`}</EmptyMessage>}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </ExpandableChildren>}
        </AnimatePresence>
    </Container>
}

type ListItemIconContainerProps = {
    color?: string,
}

const ListItemIconContainer = styled.div<ListItemIconContainerProps>`
    color: ${props => props.color ? props.color : loopStyles.colors.tertiary};
    width: 36px;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ListItem = styled.div`
    display: flex;
    position: relative;
    z-index: 1;
    align-items: center;
    ${loopStyles.transition.animationStyles}
    cursor: pointer;
    border-left: 2px solid transparent;
    text-decoration-color: ${(props: any) => props.color};
    &:hover {
        background-color: rgba(255,255,255,0.05);
        text-decoration: underline;
        border-left: 2px solid ${loopStyles.colors.tertiary};
        text-decoration-color: ${(props: any) => props.color};
    }
`

const EmptyMessage = styled.div`
    width: 100%;
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #B5B5BE;
    opacity: 0.7;
    font-size: 13px;
    line-height: 21px;
    letter-spacing: 0.1px;
`

const SidebarGroupHeader = styled.div`
    color: #B5B5BE;
    max-width: 100%;
    height: 40px;
    font-family: Poppins;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    cursor: pointer;
    ${loopStyles.transition.animationStyles}
    &:hover {
        * { 
            // color: ${loopStyles.colors.tertiary};
            ${loopStyles.transition.animationStyles}
        }
        background-color: rgba(0,0,0,0.1);
    }
`

const ExpandableChildren = styled(motion.div)`
    color: ${loopStyles.colors.secondary};
    background-color: rgba(0,0,0,0.3);
    overflow: hidden;
`

const Container = styled.div`
    
`

export default TeamSidebarGroup